import NotFoundError from 'pages/ErrorPage/NotFoundError/NotFoundError';

export default NotFoundError;